import { createSlice } from '@reduxjs/toolkit';
import { GenericEntityState, ResponseAction } from '@app/redux/types';
import createFetchReducer from '@app/utils/createFetchReducer';
import {
	getPersonalizationSettingsTypes,
	upsertPersonalizationSettingsTypes,
	PersonalizationSettingsType,
} from './types';

const DEFAULT_SETTINGS: PersonalizationSettingsType = {
	globalConfig: { influence: '' },
	messageConfig: [],
};

export const initialState: GenericEntityState = {
	loading: false,
	error: {},
	response: { status: null, message: null },
	settings: DEFAULT_SETTINGS,
	custom: {
		getPersonalizationSettingsLoading: false,
		upsertPersonalizationSettingsLoading: false,
	},
};

export type settingsStateType = typeof initialState;

const settingsMapper = (state: settingsStateType, action: ResponseAction) => {
	if (action.response?.settings) {
		state.settings = action.response.settings;
	}
};

const personalizationSettingsSlice = createSlice({
	name: 'personalizationSettings',
	initialState,
	reducers: {},
	extraReducers: {
		...createFetchReducer(getPersonalizationSettingsTypes, settingsMapper),
		...createFetchReducer(upsertPersonalizationSettingsTypes, settingsMapper),
	},
});

export default personalizationSettingsSlice.reducer;
